import type { PropSpec, PropValue, TsxInstanceFrame, TsxMainFrame } from '../../store/types';
import { useCanvasStore } from '../../store/canvas-store';

interface Props { instance: TsxInstanceFrame; main: TsxMainFrame }

export function TsxPropsForm({ instance, main }: Props) {
  const dispatch = useCanvasStore((s) => s.dispatch);
  const set = (name: string, value: PropValue) => dispatch({ t: 'tsxInstance.setProp', id: instance.id, name, value });
  const reset = (name: string) => dispatch({ t: 'tsxInstance.resetProp', id: instance.id, name });

  if (main.propsSchema.length === 0) {
    return <div className="p-3 text-sm text-[var(--color-text)] opacity-60">No props declared on this component.</div>;
  }
  return (
    <div className="flex flex-col gap-3 p-3">
      {main.propsSchema.map((spec) => {
        const overridden = spec.name in instance.propValues;
        const value = overridden ? instance.propValues[spec.name] : spec.default;
        return (
          <label key={spec.name} className="flex flex-col gap-1 text-sm text-[var(--color-text)]">
            <span className="flex items-center justify-between">
              {spec.name}
              {overridden && (
                <button className="text-xs opacity-60 hover:opacity-100" onClick={() => reset(spec.name)}>reset</button>
              )}
            </span>
            <PropControl spec={spec} value={value} onChange={(v) => set(spec.name, v)} />
          </label>
        );
      })}
    </div>
  );
}

function PropControl({ spec, value, onChange }: { spec: PropSpec; value: PropValue; onChange: (v: PropValue) => void }) {
  const cls = 'rounded border border-[var(--color-border)] bg-[var(--color-surface)] px-2 py-1';
  if (spec.type === 'boolean') {
    return <input type="checkbox" checked={Boolean(value)} onChange={(e) => onChange(e.target.checked)} />;
  }
  if (spec.type === 'number') {
    return <input className={cls} type="number" value={Number(value)} onChange={(e) => onChange(Number(e.target.value))} />;
  }
  if (spec.type === 'enum') {
    return (
      <select className={cls + ' cf-select'} value={String(value)} onChange={(e) => onChange(e.target.value)}>
        {(spec.options ?? []).map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  return <input className={cls} type="text" value={String(value)} onChange={(e) => onChange(e.target.value)} />;
}
